import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { PAYMENT_CALLS_URL } from "./constants";
import { IAutoCashoutPaymentCallsResponse } from "./models";

const defaultProvide = async () => await getToken();

export const getAutoCashoutPaymentCalls = (
  domainId: string,
  page = 0,
  size = 10
): Promise<IAutoCashoutPaymentCallsResponse> => {
  const url = `${PAYMENT_CALLS_URL(domainId)}?page=${page}&size=${size}`;
  const descriptor = new ApiServiceManager(url, "GET", defaultProvide);
  return fetchRequest(descriptor);
};
